// NB! keys are used by react only, there can be hardcoded values outside react (mentioned below) - edit carefully!
export const onboardingEventKeys = {
    stepCompleted: '@onboarding/step-completed',
    userpilotEvent: '@onboarding/run-userpilot-event',
    newProject: '@onboarding/open-new-project',
    modalOpen: '@onboarding/open-step-modal',
    modalClose: '@onboarding/close-step-modal',
};

// NB! keys are used by react only, there can be hardcoded values outside react (mentioned below) - edit carefully!
export const onboardingStorageKeys = {
    newProject: '@onboarding/open-new-project',
    userpilot: '@onboarding/userPilot-event-name',
    modal: '@lokalise/open-onboarding-modal',
    gitProvider: '@onboarding/git-path-name',
};

// outside react views:
// services/app/legacy-public-src/js/github-auth.js - Repository events
// services/app/legacy/views/project/body.twig - Editor Explore events
// services/app/legacy/views/base.twig - declared onboarding data
// services/app/legacy-public-src/ts/src/project/key-editor.ts - fire event after adding new key
// services/app/legacy-public-src/js/project/project_uploader.js - upload

export type UserPilotTriggerKeys = keyof typeof userPilotTriggerIds;

export const userPilotTriggerIds = {
    gitflow: {
        id: 8,
        triggerHash: '1639132880fYqk3436',
    },
    editorexplore: {
        id: 12,
        triggerHash: '1639548165kFcl284',
    },
    documenteditorexplore: {
        id: 44,
        triggerHash: 'iCoCsiGLIU',
    },
    editorexploreEmptyGit: {
        id: 17,
        triggerHash: '1641394882dShc0795',
    },
    editorexploreEmptyWithFailedPull: {
        id: 21,
        triggerHash: '1642064404jNpz7192',
    },
    downloadfiles: {
        id: 11,
        triggerHash: '1639489261mZvq7573',
    },
    downloadfilesPush: {
        id: 16,
        triggerHash: '1641391097mXnr9554',
    },
    downloadfilesWithNoDownloadButton: {
        id: 22,
        triggerHash: '1642080255qLfg0456',
    },
    uploadFile: {
        id: 19,
        triggerHash: '1642005459lIll8916',
    },
    editorexploreEmptyUpload: {
        id: 23,
        triggerHash: '1642415716uXfb8675',
    },
    exploreMoreFeatures: {
        id: 54,
        triggerHash: 'q6iJIxcIcN',
    },
};

export const onboardingPagePath = '/quick-start';
